import _ from "underscore";

export const getExamTypeString = (value: string) => {
    return [
        "单选",
        "多选",
        "判断",
        "主观",
        "填空",
        "听力",
        "完形填空",
        "阅读理解"
    ][parseInt(value) - 1];
};

interface answer {
    answerId: number;
    isChoose: "0" | "1";
}

export const getDanxuanSelectId = (answerList: answer[]) => {
    let answerItem = answerList.find(item => item.isChoose === "1");
    return answerItem ? answerItem.answerId : 0;
};

export const getDuoxuanSelectIdList = (answerList: answer[]) => {
    return answerList
        .filter(item => item.isChoose === "1")
        .map(item => item.answerId);
};

export const getRightAnswerCount = (list: any[], type: string) => {
    let data = _.chain(list)
        .map(item => {
            if (type === "4") {
                return parseFloat(item.markScore) || 0;
            }

            if (type === "5") {
                let rightCount = 0;
                for (let topic of item.answers) {
                    if (topic.content === topic.stuAnswer) {
                        rightCount += 1;
                    }
                }
                return (item.score * rightCount) / item.answers.length;
            }

            if (["6", "7", "8"].includes(type)) {
                let score = 0;
                for (let topic of item.topics) {
                    score += getRightAnswerCount([topic], topic.topicType);
                }
                return score;
            }

            return item.isRight === "1" ? parseFloat(item.score) : 0;
        })
        .reduce((memo, score) => {
            return memo + score;
        }, 0)
        .value();
    return data;
};

export function toNumber(value: number | string | null | undefined) {
    if (!value) return 0;
    return Number(value) || 0;
}

export function toFixedNumber(value: string | number, decimal: number = 1) {
    return parseFloat(toNumber(value).toFixed(decimal));
}
